import { AdapterRegistry, IModel, Metamodel, SnowflakeV2TableDataset } from 'shell-models-lib';
import { SnowflakeTableDatasetAdapter, snowflakeTableDatasetAdapter } from './snowflake-dataset.adapter';
import { Model } from 'app/model/backendmodel';
import { merge } from 'lodash';
import { ValueAdapter } from '../value.adapter';

const snowflakeV2TableDatasetAdapter = merge({}, snowflakeTableDatasetAdapter, {
    connectionProperties: __IS_FABRIC_DPE__ ? '*' : undefined,
    version: async () => __IS_FABRIC_DPE__ ? '*' : undefined,
    typeProperties: { tableType: __IS_FABRIC_DPE__ ? '*' : undefined }
});

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SnowflakeV2TableDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: snowflakeV2TableDatasetAdapter
    }
})
export class SnowflakeV2TableDatasetAdapter extends SnowflakeTableDatasetAdapter {
    protected override model(): IModel {
        return SnowflakeV2TableDataset.MODEL;
    }

    protected override async _toResource(dataset: SnowflakeV2TableDataset): Promise<Model.DatasetResource> {
        const resource = await super._toResource(dataset);
        if (dataset.tableType && resource?.properties?.typeProperties) {
            resource.properties.typeProperties.tableType = dataset.tableType;
        }
        resource.properties.version = __IS_FABRIC_DPE__ ?
            ValueAdapter.toResource(dataset, SnowflakeV2TableDataset.VERSION) :
            undefined;
        return resource;
    }

    protected override async _toModel(
        modelDatasetResource: Model.DatasetResource,
        dataset?: SnowflakeV2TableDataset
    ): Promise<SnowflakeV2TableDataset> {
        const model: SnowflakeV2TableDataset = await super._toModel(modelDatasetResource, dataset);
        if (modelDatasetResource?.properties?.typeProperties?.tableType) {
            model.tableType = modelDatasetResource.properties.typeProperties.tableType;
        }
        if (__IS_FABRIC_DPE__) {
            model.version = undefined;
            ValueAdapter.toModel(
                model,
                SnowflakeV2TableDataset.VERSION,
                modelDatasetResource.properties.version
            );
        }
        return model;
    }
}
